export const QueryName = {
  nextRoute: "next_route",
};
